import React from "react";
import { IconWrapper } from "../header/header.styles";
import { AppSearch } from "../../../features/app-search/components/app-search/app-search.component";
import NotificationButton from "../../../features/notification/components/notification/notification-button.component";
import ProfilePictureButton from "../../form-controls/button/profile-picture-button";
import { NotificationsDrawer } from "../../../features/notification/components/notifications-drawer/notifications-drawer.component";

export const HeaderGlobals = () => (
  <>
    <IconWrapper>
      <AppSearch />
    </IconWrapper>
    <IconWrapper>
      <NotificationButton />
    </IconWrapper>
    <IconWrapper>
      <ProfilePictureButton />
    </IconWrapper>
    <NotificationsDrawer />
  </>
);
